import { render, staticRenderFns } from "./salaryHourAdvance.vue?vue&type=template&id=706d212f"
import script from "./salaryHourAdvance.vue?vue&type=script&lang=js"
export * from "./salaryHourAdvance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports